// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#0d291c","white":"#fff","wrapper":"styles_wrapper__zZv81","container":"styles_container__ImpyD","title":"styles_title__Bx7qO","share":"styles_share__UZoEq"};